<template>
    <div>
        <div>
            <button @click="mountChild()" class="btn btn-outline-secondary btn-sm" type="button">
                {{ $t("message.find_partner.download_pdf") }}
            </button>
        </div>
        <div v-if="isChildMounted" id="invisible-child" style="display: none;">
            <slot :childFullyLoaded="childFullyLoaded" :height="height" :width="width"></slot>
        </div>
    </div>
</template>
<script>
import { jsPDF } from 'jspdf'
export default {
    props: {
        pageMarginsInPx: {
            type: Number | Array,
            default: 30,
        },
        pageFullWidthInPx: {
            type: Number,
            default: 1400,
        },
        filename: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            isChildMounted: false,
            isChildLoaded: false,
            doc: null,

            jsPdfSettings: {
                scale: null,
                scaledMargins: null,
                xMarginsSum: null,
                yMarginsSum: null,
            }
        }
    },
    mounted() {
        this.loadDoc();
    },
    computed: {
        height(){
            return Math.trunc((this.doc.internal.pageSize.getHeight() / this.jsPdfSettings.scale) - this.jsPdfSettings.yMarginsSum)// + 1 test second page
        },
        width(){
            return Math.trunc(this.doc.internal.pageSize.getWidth() / this.jsPdfSettings.scale - this.jsPdfSettings.xMarginsSum)
        },
    },
    methods: {
        mountChild() {
            this.isChildMounted = true;
        },
        childFullyLoaded() {
            // Must be called when child is fully loaded
            this.makeJsPdf();
        },
        loadDoc(){
            this.doc = new jsPDF({unit:"px", putOnlyUsedFonts:true});
            const width = this.doc.internal.pageSize.getWidth();
            const scale = width / this.pageFullWidthInPx;

            let xMarginsSum = null;
            let yMarginsSum = null;
            let scaledMargins = null;
            if (Array.isArray(this.pageMarginsInPx)){
                xMarginsSum = this.pageMarginsInPx[1] + this.pageMarginsInPx[3];
                yMarginsSum = this.pageMarginsInPx[0] + this.pageMarginsInPx[2];
                scaledMargins = this.pageMarginsInPx.map((margin) => margin * scale);
            }
            else {
                xMarginsSum = this.pageMarginsInPx * 2;
                yMarginsSum = this.pageMarginsInPx * 2;
                scaledMargins = this.pageMarginsInPx * scale;
            }
            this.jsPdfSettings.scaledMargins = scaledMargins;
            this.jsPdfSettings.xMarginsSum = xMarginsSum;
            this.jsPdfSettings.yMarginsSum = yMarginsSum;
            this.jsPdfSettings.scale = scale;

        },
        makeJsPdf() {
            let parentEl = document.getElementById("invisible-child")

            parentEl.firstChild.style.width = (this.pageFullWidthInPx - this.jsPdfSettings.xMarginsSum) + "px";
            parentEl.firstChild.style.maxWidth = (this.pageFullWidthInPx - this.jsPdfSettings.xMarginsSum) + "px";
            parentEl.firstChild.style.margin = "0px"
            this.doc.html(
                parentEl.innerHTML,
                {
                    callback: (doc) => {
                        doc.save(this.filename);
                        this.isChildMounted = false;
                    },
                    margin: this.jsPdfSettings.scaledMargins,
                    html2canvas: {
                        scale: this.jsPdfSettings.scale
                    }
                }
            )
        },
    },
};
</script>